import 'keen-slider/keen-slider.min.css'
import React, { useRef, useState, useEffect, useCallback } from 'react'

import CourseProgressCard from '../CourseProgressCard'

import { BsArrowLeftShort, BsArrowRightShort } from 'react-icons/bs'
import { Container, ButtonWrapper } from './styles'
import { learningApi } from '../../services/api'
import { useKeenSlider } from 'keen-slider/react'

const CanInterest: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const [interest, setInterest] = useState<any[]>([])
  const [pause] = useState(true)
  const token = localStorage.getItem('token')

  const timer = useRef<any>()
  const [sliderRef, slider] = useKeenSlider<HTMLDivElement>({
    mode: 'snap',
    loop: interest.length > Math.floor(window.innerWidth / 400),
    breakpoints: {
      '(max-width: 500px)': {
        slides: { perView: 1, spacing: 5 },
      },
      '(min-width: 1000px)': {
        slides: { perView: 4, spacing: 10 },
      },
    },
    slideChanged(s) {
      setCurrentSlide(s.track.details.rel)
    },
  })

  useEffect(() => {
    timer.current = setInterval(() => {
      if (!pause && slider.current.next.length > 0) {
        slider.current.next()
      }
    }, 7000)
    return () => {
      clearInterval(timer.current)
    }
  }, [pause, slider])

  const ArrowLeft = useCallback(({ disabled, onClick }) => {
    const disabeld = disabled ? ' arrow--disabled' : ''
    return (
      <button className={'arrow arrow--left' + disabeld} onClick={onClick}>
        <BsArrowLeftShort size={27} />
      </button>
    )
  }, [])

  const ArrowRight = useCallback(({ disabled, onClick }) => {
    const disabeld = disabled ? ' arrow--disabled' : ''
    return (
      <button className={'arrow arrow--right' + disabeld} onClick={onClick}>
        <BsArrowRightShort size={27} />
      </button>
    )
  }, [])

  const getInterest = useCallback(async () => {
    const response = await learningApi.get('/recommendation', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    setInterest(response.data)
  }, [token])

  useEffect(() => {
    getInterest()
  }, [getInterest])

  return interest.length ? (
    <Container>
      <h2 className="title">Podem interessar</h2>
      <div ref={sliderRef} className="keen-slider sliderStyle">
        {interest.map((item, idx) => (
          <div className={`keen-slider__slide number-slide${idx}`} key={idx}>
            <CourseProgressCard
              name={item?.name}
              numberOfModules={item.numberOfModules}
              courseId={item._id}
              icon={item.icon}
              isFreemium={true}
              percentage={item.progress}
            />
          </div>
        ))}
      </div>
      {interest.length > Math.floor(window.innerWidth / 320) && (
        <ButtonWrapper>
          <ArrowLeft
            onClick={(e: any) => e.stopPropagation() || slider.current?.prev()}
            disabled={currentSlide === 0}
          />
          <ArrowRight
            onClick={(e: any) => e.stopPropagation() || slider.current?.next()}
            disabled={
              currentSlide && currentSlide === slider.current?.track.details.slides.length - 1
            }
          />
        </ButtonWrapper>
      )}
    </Container>
  ) : (
    <div />
  )
}

export default CanInterest
